<template>
  <div class="q-px-lg q-px-md-xl">
    <h5 class="text-h5 text-light-blue">Say Goodbye to Lost Links</h5>
      <p>Memo Link uses your keywords, so you always know what’s behind the link—and can find it later in a snap!</p>
      <h5 class="text-h5 text-light-blue">Share Smarter, Find Faster</h5>
  </div>
</template>

<script setup>

</script>

<style scoped>
h5 {
  font-weight: bold;
  margin-bottom: 1em;
}

* {
  color: #5d5d5d;
}
</style>
